import { render } from "./AddConcept.vue?vue&type=template&id=3abf9c67&scoped=true"
import script from "./AddConcept.vue?vue&type=script&lang=js"
export * from "./AddConcept.vue?vue&type=script&lang=js"

import "./AddConcept.vue?vue&type=style&index=0&id=3abf9c67&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abf9c67"]])

export default __exports__